import { render } from "./ForgotPage.vue?vue&type=template&id=e937f3ec&scoped=true"
import script from "@/assets/js/forgot.js?vue&type=script&defer=true&lang=js&external"
export * from "@/assets/js/forgot.js?vue&type=script&defer=true&lang=js&external"

import "@/assets/css/forgot.css?vue&type=style&index=0&id=e937f3ec&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e937f3ec"]])

export default __exports__